var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionsIconBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 17C6.20914 17 8 15.2091 8 13C8 10.7909 6.20914 9 4 9C1.79086 9 0 10.7909 0 13C0 15.2091 1.79086 17 4 17ZM4 15.5C5.38071 15.5 6.5 14.3807 6.5 13C6.5 11.6193 5.38071 10.5 4 10.5C2.61929 10.5 1.5 11.6193 1.5 13C1.5 14.3807 2.61929 15.5 4 15.5Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 26C6.20914 26 8 24.2091 8 22C8 19.7909 6.20914 18 4 18C1.79086 18 0 19.7909 0 22C0 24.2091 1.79086 26 4 26ZM4 24.5C5.38071 24.5 6.5 23.3807 6.5 22C6.5 20.6193 5.38071 19.5 4 19.5C2.61929 19.5 1.5 20.6193 1.5 22C1.5 23.3807 2.61929 24.5 4 24.5Z",
    fill: "#04B7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 31C8 33.2091 6.20914 35 4 35C1.79086 35 0 33.2091 0 31C0 28.7909 1.79086 27 4 27C6.20914 27 8 28.7909 8 31ZM6.5 31C6.5 32.3807 5.38071 33.5 4 33.5C2.61929 33.5 1.5 32.3807 1.5 31C1.5 29.6193 2.61929 28.5 4 28.5C5.38071 28.5 6.5 29.6193 6.5 31Z",
    fill: "#04B7EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30C13.4477 30 13 30.4477 13 31C13 31.5523 13.4477 32 14 32H43C43.5523 32 44 31.5523 44 31C44 30.4477 43.5523 30 43 30H14Z",
    fill: "#04B7EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21C13.4477 21 13 21.4477 13 22C13 22.5523 13.4477 23 14 23H43C43.5523 23 44 22.5523 44 22C44 21.4477 43.5523 21 43 21H14Z",
    fill: "#04B7EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C13.4477 12 13 12.4477 13 13C13 13.5523 13.4477 14 14 14H43C43.5523 14 44 13.5523 44 13C44 12.4477 43.5523 12 43 12H14Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIconBig);
export default __webpack_public_path__ + "static/media/OptionsIconBig.7c877bc37d60e962b3aa9c2b7b3b9100.svg";
export { ForwardRef as ReactComponent };